import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropdown", "button"];

  navigate() {
    const selectedOption = this.dropdownTarget.options[this.dropdownTarget.selectedIndex];
    const url = selectedOption.value;
    window.open(url, '_self').focus();
  }
}
